module.exports = __webpack_public_path__ + "img/a3.3e4382a1.png";